import { render, staticRenderFns } from "./SpecialModelTest.vue?vue&type=template&id=b6399b2e&"
import script from "./SpecialModelTest.vue?vue&type=script&lang=js&"
export * from "./SpecialModelTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports